export default __webpack_public_path__ + "static/media/volunteer2.4b69d6ef.jpg";